/* ==========================================================================
 * coldest-sticky-atc-guard.js
 * --------------------------------------------------------------------------
 * Prevents duplicate add-to-cart from the sticky bar (#cro-sticky-atc).
 *
 * Background: the sticky "ADD TO CART" button (.cro-sticky-btn, built by
 * coldest-phase2-fixes.js) has TWO click paths:
 *   1. Native path — guarded by a `.cro-loading` busy-lock, clicks the real
 *      product form ATC button.
 *   2. GPO path — for products with Globo product options, a capture-phase
 *      handler calls stopImmediatePropagation() and clicks the GPO clone
 *      button. This path has NO busy-lock, so rapid taps on a GPO product
 *      add the item to the cart more than once.
 *
 * This guard sits at document level in the CAPTURE phase, so it runs BEFORE
 * any element-level handler (capture handlers fire top-down through the tree).
 * The first qualifying tap is let through untouched; further taps within the
 * lock window are swallowed. It deliberately does NOT add `.cro-loading` —
 * doing so before the native handler runs would make that handler think an
 * add is already in flight and skip it entirely.
 * ========================================================================== */
(function () {
  'use strict';

  var SELECTOR = '#cro-sticky-atc .cro-sticky-btn';
  var LOCK_MS = 2000; // matches the native handler's loading window
  var locked = false;
  var lockTimer = null;

  function unlock() {
    locked = false;
    if (lockTimer) { clearTimeout(lockTimer); lockTimer = null; }
  }

  function lock() {
    locked = true;
    if (lockTimer) clearTimeout(lockTimer);
    // Safety backstop: release the lock even if no cart event fires (e.g. the
    // add was blocked by engraving validation) so the user can retry.
    lockTimer = setTimeout(unlock, LOCK_MS);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest(SELECTOR);
    if (!btn) return;

    if (locked) {
      // Duplicate tap while an add is already in flight — swallow it before
      // any of the sticky button's own click handlers can fire again.
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }

    // First tap: arm the lock and let this event continue to the real handlers.
    lock();
  }, true);

  // Release as soon as the cart actually changes so a legitimate second add
  // (after the first completes) isn't blocked for the full window.
  ['cart:updated', 'cart:refresh', 'cart:change', 'gpoAddedToCart'].forEach(function (evt) {
    document.addEventListener(evt, unlock);
  });
})();
